<template>
	<BaseOverlay @close="$emit('close', 'overlay')">
		<div
			class="base-modal bg-white dark:bg-gray-650"
			:class="accentColor && `${accentColor}-accent`"
			:style="{width}"
		>
			<header class="flex items-center">
				<h1 v-if="$slots.title" class="text-strong-base text-gray-100 flex-1">
					<slot name="title" />
				</h1>
				<button class="link-gray ml-auto" title="Close" @click="$emit('close', 'close-button')">
					<BaseIcon name="mono/delete" class="m-4 w-10 h-10" />
				</button>
			</header>
			<main class="text-gray-300 overflow-y-auto visible-scrollbars">
				<slot />
			</main>
			<footer v-if="$slots.footer" class="flex justify-end space-x-16">
				<slot name="footer" />
			</footer>
		</div>
	</BaseOverlay>
</template>

<script>
export default {
	name: 'BaseModal',
	props: {
		width: {type: String, default: '360px'},
		accentColor: {
			type: String,
			default: undefined,
			validator: function (value) {
				return [undefined, 'red', 'yellow', 'green'].includes(value)
			},
		},
	},
	emits: ['close'],
}
</script>

<style scoped>
.base-modal {
	max-height: calc(100vh - 32px * 2);
	max-width: calc(100vw - 32px * 2);
	padding: 16px 20px;
	border-radius: 4px;
	overflow: hidden;
	display: flex;
	flex-direction: column;
}

.base-modal > * + * {
	margin-top: 16px;
}

.green-accent {
	box-shadow: 0px -4px 0px var(--green-500);
}
.yellow-accent {
	box-shadow: 0px -4px 0px var(--yellow-500);
}
.red-accent {
	box-shadow: 0px -4px 0px var(--red-500);
}
</style>
